// TODO: P0: posting ml.pdf freezes. Generally the text area is very slow
// TODO: P2: add number of characters
// TODO: P1: add 'type' to addArticle calls
import React, { useEffect, useMemo, useCallback, useState } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import loadingIcon from '../Assets/loading.gif';
import { addArticleToUserPlaylist, getPresignedUrl, uploadTextToPresignedUrl, getUserPlaylist, createReactivationCheckoutSession } from '../audiblogsApi';
import userStore from '../Stores/User';
import gamificationStore from '../Stores/GamificationStore';
import store from './DiscoverNew/store.js';
import { observer } from 'mobx-react';
import { set } from 'mobx';
import { Modal, mergeStyleSets } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { isPaidProUser, hasPaidPlan } from '../constants/plans';
import { createStripeSessionAndRedirectToCheckout } from '../stripeLogic';

const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column',
    backgroundColor: 'rgb(66 59 74)',
    width: '400px', // Increased width for better layout
    padding: '20px', // Increased padding
    fontFamily: 'Cabin',
    fontSize: '18px',
    textAlign: 'center',
    minHeight: '108px',
    borderRadius: '14px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Added shadow
  },
});

const EditText = observer(({ location: { search } }) => {
  const params = queryString.parse(search);
  const type = params.type || 'input_text';
  const articleUrl = params.url || '';
  const [title, setTitle] = useState(
    params.title || new Date().toString().split('GMT')[0].trim()
  );
  const [text, setText] = useState(params.text || '');
  const [backupText, setBackupText] = useState(params.backupText || '');
  const [extractionMethod, setExtractionMethod] = useState('A');
  const [isLoading, setIsLoading] = useState(false);
  const [buttonMessage, setButtonMessage] = useState('Send');
  const ARTICLE_MAX_LENGTH_HD = 100000;
  const ARTICLE_MAX_LENGTH_FREE_TIER = 10000;
  const [maxLength, setMaxLength] = useState(ARTICLE_MAX_LENGTH_FREE_TIER);
  const [preSignedUrl, setPreSignedUrl] = useState('');
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);
  const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);
  const [isUpgrading, setIsUpgrading] = useState(false);

  // Helper function to estimate audio duration
  const estimateAudioDuration = (charCount) => {
    // More accurate estimate: 10k chars ≈ 10.5 minutes of audio
    // This accounts for natural pauses, punctuation, and speech rate
    const minutes = Math.round((charCount / 10000) * 10.5);
    return minutes;
  };

  const isPaidUser = hasPaidPlan(userStore.user);

  // Add checkMonthlyConversions function
  const checkMonthlyConversions = async () => {
    // TODO: users can technically get around this by creating an article and then deleting it; should include deleted articles in the count
    try {
      const response = await getUserPlaylist(userStore.idToken);
      const articles = response || [];
      
      // Get date 30 days ago
      const now = new Date();
      const thirtyDaysAgo = new Date(now.getTime() - (30 * 24 * 60 * 60 * 1000));
      
      console.log('Checking monthly conversions:', {
        totalArticles: articles.length,
        thirtyDaysAgo: thirtyDaysAgo.toISOString(),
        now: now.toISOString()
      });
      
      // Count non-feed articles from last 30 days
      const monthlyConversions = articles.filter(article => {
        const articleDate = new Date(article.date_added);
        const isRecent = articleDate >= thirtyDaysAgo;
        const isNotFeed = !article.feed_id;
        const isNotKeyFeatures = article.article_id !== 'audioread.com/key-features-and-how-tos';
        
        console.log('Article check:', {
          articleId: article.article_id,
          dateAdded: article.date_added,
          articleDate: articleDate.toISOString(),
          isRecent,
          isNotFeed,
          isNotKeyFeatures,
          feedId: article.feed_id
        });
        
        return isNotFeed && isRecent && isNotKeyFeatures;
      }).length;
      
      console.log('Monthly conversions result:', {
        monthlyConversions
      });
      
      return monthlyConversions;
    } catch (error) {
      console.error('Error checking monthly conversions:', error);
      return 0;
    }
  };

  function breakStringIntoChunks(text, maxSize) {
    const paragraphs = text.split('\n'); // Split the text into paragraphs
    
    let chunk = ''; // Initialize an empty chunk
    let result = []; // Initialize an array to store the chunks
    
    for (let i = 0; i < paragraphs.length; i++) {
      const paragraph = paragraphs[i];
      const chunkSize = chunk.length + paragraph.length;
      
      if (chunkSize <= maxSize) {
        chunk += paragraph + '\n'; // Add the paragraph to the chunk with a newline
      } else {
        result.push(chunk.trim()); // Add the completed chunk to the result array
        chunk = paragraph + '\n'; // Start a new chunk with the current paragraph
      }
    }
    
    if (chunk.length > 0) {
      result.push(chunk.trim()); // Add the last chunk if it's not empty
    }
    
    return result;
  }

  useEffect(async () => {
    const preSignedUrl = await getPresignedUrl('txt');
    setPreSignedUrl(preSignedUrl);
  }, []);

  useEffect(() => {
    if (isPaidUser) {
      setMaxLength(ARTICLE_MAX_LENGTH_HD);
      setShowUpgradePrompt(false);
    } else {
      setMaxLength(ARTICLE_MAX_LENGTH_FREE_TIER);
      // Show upgrade prompt when approaching 80% of free tier limit
      const currentLength = extractionMethod === 'A' ? text.length : backupText.length;
      setShowUpgradePrompt(currentLength > ARTICLE_MAX_LENGTH_FREE_TIER * 0.8);
    }
  }, [isPaidUser, text.length, backupText.length, extractionMethod]);

  const showCharacterLimitModal = (current_usage = 0, limit = 1000000) => {
    const CharacterPurchaseModal = () => {
      const [charAmount, setCharAmount] = useState(1); // Default to 1M characters
      const pricePerMillion = 15;
      const totalPrice = (charAmount * pricePerMillion).toFixed(2);
      
      return (
        <>
          <div style={{ color: 'white', marginBottom: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}>
            Character Limit Reached
            <a href="https://help.audioread.com/en/articles/11783511-how-extra-characters-work" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
              <span style={{ border: '1px solid white', borderRadius: '50%', width: '16px', height: '16px', display: 'inline-flex', justifyContent: 'center', alignItems: 'center', lineHeight: 1 }}>?</span>
            </a>
          </div>
          <div style={{ color: 'white', marginBottom: '20px' }}>
            You've used {current_usage.toLocaleString()} of {limit.toLocaleString()} characters in the last 30 days. Purchase additional characters that will be used for any overages beyond your plan's allotment.
          </div>
          
          <div style={{ marginBottom: '20px', textAlign: 'left' }}>
            <div style={{ color: 'white', marginBottom: '10px' }}>
              Select amount to purchase:
            </div>
            <input
              type="range"
              min="1"
              max="10"
              value={charAmount}
              onChange={(e) => setCharAmount(Number(e.target.value))}
              style={{ width: '100%' }}
            />
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              color: 'white',
              marginTop: '5px'
            }}>
              <div>{charAmount}M characters</div>
              <div>${totalPrice}</div>
            </div>
            <div style={{ 
              color: '#4CAF50', 
              fontSize: '14px',
              marginTop: '5px' 
            }}>
              ~{Math.round((charAmount * 1000000 / 10000) * 10.5)} minutes of audio
            </div>
          </div>
          
          <button
            onClick={async () => {
              try {
                setIsLoading(true);
                // Create a one-time checkout session for character purchase
                const response = await createStripeSessionAndRedirectToCheckout(userStore.idToken, {
                  mode: 'payment',
                  amount: charAmount * pricePerMillion * 100, // Convert to cents
                  currency: 'usd',
                  metadata: {
                    type: 'character_purchase',
                    characters: charAmount * 1000000
                  }
                });
              } catch (error) {
                console.error('Error creating character purchase session:', error);
                setModalContent({
                  title: "Error",
                  message: "Unable to process payment. Please try again or contact support.",
                });
              } finally {
                setIsLoading(false);
              }
            }}
            className="clickable"
            style={{
              backgroundColor: '#1976d2',
              border: 'none',
              color: 'white',
              borderRadius: '9px',
              marginTop: '14px',
              marginRight: '10px',
              fontSize: '16px',
              padding: '8px 16px',
              outline: 'none',
              cursor: 'pointer',
            }}
          >
            {isLoading ? (
              <img src={loadingIcon} style={{ height: '25px' }} alt="loading..." />
            ) : (
              `Purchase for $${totalPrice}`
            )}
          </button>
          
          <button
            onClick={() => {
              window.Intercom('show');
              hideModal();
            }}
            className="clickable"
            style={{
              backgroundColor: 'transparent',
              border: '1px solid lightgrey',
              color: 'white',
              borderRadius: '9px',
              marginTop: '14px',
              fontSize: '16px',
              padding: '2px 8px',
              outline: 'none',
            }}
          >
            Contact Support
          </button>
        </>
      );
    };

    setModalContent({
      customContent: <CharacterPurchaseModal />
    });
    showModal();
  };

  // For testing, you can call this:
  // useEffect(() => {
  //   if (isModalOpen) {
  //     showCharacterLimitModal(150000, 100000);
  //   }
  // }, [isModalOpen]);

      return (
    <div className="center-static">
      <Modal
        isOpen={isModalOpen}
        onDismiss={hideModal}
        isBlocking={false}
        isDarkOverlay={true}
        containerClassName={contentStyles.container}
      >
        <div>
          {modalContent?.customContent ? (
            modalContent.customContent
          ) : modalContent ? (
            <>
              <div style={{ color: 'white', marginBottom: '15px', fontWeight: 'bold' }}>
                {modalContent.title}
              </div>
              <div style={{ color: 'white', marginBottom: '15px' }}>
                {modalContent.message}
              </div>
              {modalContent.actionText && (
                <button
                  onClick={modalContent.actionHandler}
                  className="clickable"
                  style={{
                    backgroundColor: '#1976d2',
                    border: 'none',
                    color: 'white',
                    borderRadius: '9px',
                    marginTop: '14px',
                    marginRight: '10px',
                    fontSize: '16px',
                    padding: '8px 16px',
                    outline: 'none',
                    cursor: 'pointer',
                  }}
                >
                  {modalContent.actionText}
                </button>
              )}
              <button
                onClick={hideModal}
                className="clickable"
                style={{
                  backgroundColor: 'transparent',
                  border: '1px solid lightgrey',
                  color: 'white',
                  borderRadius: '9px',
                  marginTop: '14px',
                  fontSize: '16px',
                  padding: '2px 8px',
                  outline: 'none',
                }}
              >
                Close
              </button>
            </>
          ) : null}
        </div>
      </Modal>

      <h1>
        {type === 'pdf'
          ? 'PDF Conversion'
          : type === 'selection_text'
          ? 'Highlighted Text'
          : 'Copy & Paste Text'}
      </h1>

      {type === 'pdf' ? (
        <div>
          <div style={{ maxWidth: '600px' }}>
            <b>NOTE</b>: Please make sure there aren't linebreaks in the middle
            of what are supposed to be single lines or paragraphs (especially
            with math equations, figures, etc).
          </div>
          <button
            className="transparent-button mobile clickable"
            style={{
              border: extractionMethod === 'A' && '3px solid #fb1c7f',
            }}
            onClick={() => {
              setExtractionMethod('A');
            }}
          >
            Version 1
          </button>
          <button
            className="transparent-button mobile clickable"
            style={{
              border: extractionMethod === 'B' && '3px solid #fb1c7f',
            }}
            onClick={() => {
              setExtractionMethod('B');
            }}
          >
            Version 2
          </button>
        </div>
      ) : (
        <div></div>
      )}
      <form
        style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        onSubmit={ async (e) => {
          e.preventDefault();

          // Skip length check if user is upgrading
          if (!isUpgrading) {
            if (text.length > ARTICLE_MAX_LENGTH_HD) {
              alert(`Text is too long. Please keep it under ${ARTICLE_MAX_LENGTH_HD} characters.`);
              return;
            }
            
            // Check if text is too short
            const textToCheck = extractionMethod === 'A' ? text : backupText;
            if (textToCheck.length < 20) {
              const confirmed = window.confirm("Text under 20 characters tends to convert poorly. Do you want to continue anyway?");
              if (!confirmed) {
                return;
              }
            }
          }

          // Check monthly character limit for all users, and conversion count for unpaid users
          const conversions = await checkMonthlyConversions();
          
          // Only check conversion count limit for unpaid users
          if (!isPaidUser && conversions >= 3) {
            setModalContent({
              title: "Limit Reached",
              message: `You've reached your limit of 3 article conversions in the last 30 days. Upgrade to a paid plan for up to ~${estimateAudioDuration(1000000)} minutes of articles conversions per month.`,
              actionText: "Upgrade Now",
              actionHandler: () => {
                // Check if user has a customer_id but no active subscription (cancelled)
                const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
                const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
                
                if (hasStripeCustomerId && !hasActiveSubscription) {
                  createReactivationCheckoutSession(userStore.idToken, {}, '/add')
                    .then(response => {
                      if (response.data.url) {
                        window.location.href = response.data.url;
                      } else {
                        window.location.href = '/onboarding/choosevoice';
                      }
                    })
                    .catch(() => {
                      window.location.href = '/onboarding/choosevoice';
                    });
                } else {
                  window.location.href = '/onboarding/choosevoice';
                }
                hideModal();
              }
            });
            showModal();
            return;
          }
          
          setButtonMessage('Uploading...')
          setIsLoading(true);
          let txtFileUrl = ''
          try {
            const res = await uploadTextToPresignedUrl(preSignedUrl, text, setButtonMessage)
            txtFileUrl = res.config.url.split('?')[0]
          } catch (err) {
            console.log(err)
            setButtonMessage('Upload Failed')
            setIsLoading(false)
            setModalContent({
              title: "Upload Failed",
              message: "The upload failed, likely due to a slow or unstable internet connection. Please check your connection and try again.",
              actionText: "Retry Upload",
              actionHandler: () => {
                hideModal();
                // Reset state and retry the form submission
                setButtonMessage('Send');
                setTimeout(() => {
                  document.querySelector('form').dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                }, 100);
              }
            });
            showModal();
            return;
          }
          

          setButtonMessage('Sending...')
          
          // Set a timeout to auto-progress after 15 seconds
          const timeout = setTimeout(() => {
            setIsLoading(false);
            setButtonMessage('Processing in background...');
            window.location.href = '/add';
          }, 1000);

          addArticleToUserPlaylist(
            {
              title: title,
              type: type,
              article_url: txtFileUrl,
              article_id: txtFileUrl.replace("https://", ""),
              text: ""
            }, 
            userStore.idToken,
            '/add/text'
          ).then((response) => {
            // Award bonus characters for adding first article - only on success
            console.log('Article added successfully, awarding ADD_ARTICLE bonus...');
            console.log('User authenticated:', !!userStore.idToken);
            console.log('Gamification store initialized:', gamificationStore.isInitialized);
            console.log('Action already completed:', gamificationStore.isActionCompleted(gamificationStore.actions.ADD_ARTICLE));
            
            const result = gamificationStore.completeAction(gamificationStore.actions.ADD_ARTICLE);
            console.log('Bonus award result:', result);
            
            clearTimeout(timeout);
            setIsLoading(false);
            setButtonMessage('Sent!');
            window.location.href = '/add';
          }).catch((err) => {
            clearTimeout(timeout);
            setIsLoading(false);
            
            // Handle character limit error (429)
            if (err.response?.status === 429) {
              const { current_usage, limit } = err.response.data;
              showCharacterLimitModal(current_usage, limit);
            } else {
              setButtonMessage('Failed to Send');
            }
          });
        }}
      >
        <input
          type="text"
          placeholder="Title"
          value={title}
          className="input-text"
          onChange={(e) => setTitle(e.target.value)}
          style={{ marginBottom: '10px' }}
        ></input>

        <textarea
          id="input-text-area"
          name="text"
          className="input-text"
          value={extractionMethod === 'A' ? text : backupText}
          autoFocus={true}
          onChange={(e) => {
            if (extractionMethod === 'A') {
              setText(e.target.value);
            } else {
              setBackupText(e.target.value);
            }
          }}
          style={{ height: '39vh' }}
        ></textarea>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div
            style={{
              color: (extractionMethod === 'A' ? text.length : backupText.length) > maxLength ? 'red' : 'inherit',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <span>
              {extractionMethod === 'A' ? text.length : backupText.length} / {maxLength} characters
              {' '}(~{estimateAudioDuration(extractionMethod === 'A' ? text.length : backupText.length)} min)
            </span>
            {!isPaidUser && (
              <span style={{ fontSize: '14px', color: '#666' }}>
                (Free tier: 10k chars / ~{estimateAudioDuration(10000)} min)
              </span>
            )}
          </div>
          
          {showUpgradePrompt && !isPaidUser && (
            <div style={{ 
              backgroundColor: '#fff3cd', 
              color: '#856404', 
              padding: '10px', 
              borderRadius: '4px',
              fontSize: '14px'
            }}>
              <strong>Upgrade to Pro</strong> to convert articles up to 100,000 characters (~{estimateAudioDuration(100000)} min)! 
              <button
                onClick={() => {
                  setIsUpgrading(true);
                  // Check if user has a customer_id but no active subscription (cancelled)
                  const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
                  const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
                  
                  if (hasStripeCustomerId && !hasActiveSubscription) {
                    createReactivationCheckoutSession(userStore.idToken, {}, '/add')
                      .then(response => {
                        if (response.data.url) {
                          window.location.href = response.data.url;
                        } else {
                          window.location.href = '/onboarding/choosevoice';
                        }
                      })
                      .catch(() => {
                        window.location.href = '/onboarding/choosevoice';
                      });
                  } else {
                    window.location.href = '/onboarding/choosevoice';
                  }
                }}
                style={{
                  marginLeft: '10px',
                  backgroundColor: '#1976d2',
                  border: 'none',
                  color: 'white',
                  borderRadius: '4px',
                  padding: '4px 8px',
                  cursor: 'pointer'
                }}
              >
                Upgrade Now
              </button>
            </div>
          )}
        </div>
        <div>
          <div className="confirm">
            <button type="submit" className="send-text-cta" style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              {isLoading && (<img
                  src={loadingIcon}
                  style={{ height: '25px', marginRight: '5px' }}
                  alt="loading..."
                />)} <span>{buttonMessage}</span>
            </button>
            <Link
              to="/add"
              onClick={(e) => {
                store.updateAddUrl('');
              }}
            >
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
});

export default EditText;
